import { STATUS_TYPES } from '_atoms/Status/constants';
import type { CandidateSummaryStatus } from 'store/reducers/jobReducer';
import type { SummaryState, SummaryStateContent, SummaryStatusConfig } from './types';

export const EMPTY_SUMMARY_VALUE = '—';
export const SUMMARY_ACCEPTED_ICON_VIEWBOX = '3 3 18 18';
export const SUMMARY_TEXT_MAX_LENGTH = 10000;
export const SUMMARY_POINT_MAX_LENGTH = 250;

export const SUMMARY_STATUSES = {
  EMPTY: 'empty',
  NOT_ENOUGH_DATA: 'not_enough_data',
  GENERATED: 'generated',
  ERROR: 'error',
} as const satisfies Record<string, CandidateSummaryStatus>;

export const SUMMARY_STATE_CONTENT = {
  [SUMMARY_STATUSES.EMPTY]: {
    titleKey: 'translation:job_candidate_summary.empty_title',
    descriptionKey: 'translation:job_candidate_summary.empty_description',
  },
  [SUMMARY_STATUSES.NOT_ENOUGH_DATA]: {
    titleKey: 'translation:job_candidate_summary.not_enough_data_title',
    descriptionKey: 'translation:job_candidate_summary.not_enough_data_description',
  },
  [SUMMARY_STATUSES.ERROR]: {
    titleKey: 'translation:job_candidate_summary.error_title',
    descriptionKey: 'translation:job_candidate_summary.error_description',
  },
} as const satisfies Record<SummaryState, SummaryStateContent>;

export const SUMMARY_STATUS_CONFIG = {
  [SUMMARY_STATUSES.EMPTY]: {
    labelKey: 'translation:job_candidate_summary.status_empty',
    type: STATUS_TYPES.GRAY,
  },
  [SUMMARY_STATUSES.NOT_ENOUGH_DATA]: {
    labelKey: 'translation:job_candidate_summary.status_not_enough_data',
    type: STATUS_TYPES.YELLOW,
  },
  [SUMMARY_STATUSES.GENERATED]: {
    labelKey: 'translation:job_candidate_summary.status_generated',
    type: STATUS_TYPES.GRAY,
  },
  [SUMMARY_STATUSES.ERROR]: {
    labelKey: 'translation:job_candidate_summary.status_error',
    type: STATUS_TYPES.RED,
  },
} as const satisfies Record<CandidateSummaryStatus, SummaryStatusConfig>;
